import { ProductBundle, SelectableItem } from '~/models/CampaignModel';
import { ProductType } from '~/models/product/ProductType';
import { SelectionMode } from '~/models/SelectionModel';

export const BYOD_PRODUCT_ID = 'rtv_receiver_byod_product';
export const BYOD_COMMERCIAL_PRODUCT_ID = -9999;
export const BYOD_PRODUCT_NAME = 'Eget utstyr';
export const BYOD_BUNDLE_ID = 'rtv_receiver_byod_bunndle';

export const REMOTE_INSTALLATION_PRODUCT_KEY = 'remote-installation';

const BYODProduct: SelectableItem = {
  id: BYOD_PRODUCT_ID,
  productType: ProductType.Receiver,
  isPreChosen: false,
  // @ts-expect-error
  displayData: {
    name: BYOD_PRODUCT_NAME,
  },
  // @ts-expect-error
  offer: { commercialProductId: BYOD_COMMERCIAL_PRODUCT_ID },
  pricing: {
    isRecurring: false,
    price: 0,
    originalPrice: 0,
    offerPeriodInMonths: 0,
    offerEndDate: undefined,
  },
};

export const BYODProductBundle: ProductBundle = {
  id: BYOD_BUNDLE_ID,
  title: 'BYOD',
  offers: [BYODProduct],
  selectionConfig: { maxItems: 1, maxDiscountedItems: 1, selectionMode: SelectionMode.Single, showProductHats: true },
};
